import { Token } from './../models/token';
// import { NetworkService } from './network.service';
import { User } from './../models/user';
import { UserSession } from './../session/user.session';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jwtDecode } from "jwt-decode";
import { environment } from '../../environments/environment';
import { NavController } from '@ionic/angular';


@Injectable()
export class AuthenticationService {

    constructor(
        private http: HttpClient, 
        private userSession : UserSession,
        private router: NavController,
    ) { }

    private httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
        })
    };

    private getHeaderWithToken() : HttpHeaders {
        return new HttpHeaders({
            'authorization': 'Bearer ' + this.getToken(),
            'reportProgress' : 'true',
            'observe' : 'events'
          });
    }

    login(username: string, password: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.http.post<{ accessToken: string, userInfo: User }>(environment.serverUrl + 'api/auth/login', JSON.stringify({username: username, password: password}), this.httpOptions)
            .subscribe({
                next: (response) => {
                    var token : string = response && response.accessToken;
                
                    if (token) {
                        var userInfo : User = response && response.userInfo;
                        localStorage.setItem('dssdsdj', token);
                        var decoded : Token = jwtDecode(token); 
                        this.userSession.authorities = decoded.authorities;
                        this.userSession.isAuthenticated.next(true);
                        this.userSession.setAvatar(userInfo.avatarUrl);
                        this.userSession.setUsername(userInfo.username);
                        
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                },
                error: (error ) => {
                    if(error.error != null && error.error.message != null) {
                        reject(error.error.message);
                    } else {
                        reject('Connection failed.');
                    }
                }
            });
        });
    }

    async navigateAfterSuccess() {
        await this.router.navigateForward(['/recipes']);
        this.userSession.appPages = [];
        this.userSession.isAuthenticated.next(true)
    }

    logout() : void {
        localStorage.removeItem('dssdsdj');
        this.userSession.isAuthenticated.next(false);
        // this.userService.isAuthenticated = false;

        // not logged in so redirect to login page with the return url
        this.router.navigateRoot(['/login']);
    }

    async verifyAuthentication() : Promise<boolean> {
        return new Promise<boolean>(resolve => {
            this.http.get(environment.serverUrl + 'ping', { headers: this.getHeaderWithToken() }).subscribe({
                next: () => {
                    resolve(true)
                },
                error: () => {
                    resolve(false)
                }
            });
        });
    }

    getToken(): String {
        var token = localStorage.getItem('dssdsdj');
        var username = localStorage.getItem('username');

        this.userSession.setUsername(username ?? '');

        // if(token != null) {
        //     var decoded : Token = jwt_decode(token);
        //     this.userSession.authorities = decoded ? decoded.authorities : [];
        // } else {
        //     this.userSession.authorities = []
        // }
        
        return token ? token : "";
    }
}